import React, { Component } from 'react';
import PropTypes from "prop-types";
import { connect } from 'react-redux';
import BreadcrumbComponent from "../../../../CommonComponents/Breadcrumb/Breadcrumb";
import CharitySelect from "./Component/CharitySelect/CharitySelect";
import { FixedWidth } from "../../../../CommonComponents/commonStyles";
import { getPrimaryAccount, getAccountData } from '../../../../utils/sessionUtil';
import { initiateTracking,isAllShareAllPool } from '../../../../utils/commonUtil';
import { getFreezeFeaturesList } from '../../../../utils/freezeUtil';
import { newGrant } from "./actions";

export class FindCharity extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.newGrant();
  }

  breadcrumbRoutes = () => [
    {
      routeName: "Home",
      path: "/"
    },
    {
      routeName: "Grants",
      path: "/grants"
    },
    {
      routeName: "Find a charity",
      path: ""
    }
  ];

  activityBlocked = () => {
    const { partyFreezes = [] } = getAccountData();
    const { role, freezes = [] } = getPrimaryAccount();
    let isAllShareAllPoolStatus = isAllShareAllPool();
    // Select button will take to Recommend a grant flow, so checking against that
    const featureFrozen = getFreezeFeaturesList(partyFreezes, freezes).includes("RAG");
    if (featureFrozen) {
      return "Transactions for this account are frozen";
    } else if (role && role.access === 'Read Only') {
      return "Your account is read only";
    } else if (this.props.availableBalance === 0) {
      return "You have insufficient balance to continue with this transaction."
    }else if (isAllShareAllPoolStatus) {
      return "A grant has been recommended to close the account. Additional grant transactions cannot be submitted."
    }
    return "";
  }

  analyticsHandler = (dataLayerName, event, name) => {
    initiateTracking(dataLayerName, "Find a charity", event, name);
  };

  render() {
    return (
      <FixedWidth>
        <BreadcrumbComponent breadcrumbRoutes={this.breadcrumbRoutes()} />
        <CharitySelect findCharity className="px0" activityBlocked={this.activityBlocked()}
        accountId={getPrimaryAccount().userId} analyticsHandler={this.analyticsHandler} isFull={true}/>
      </FixedWidth>
    )
  }
}

const mapStateToProps = state => ({
  availableBalance: state.getIn(["globalState", "availableBalance"]),
});

export const mapDispatchToProps = dispatch => ({
  newGrant: data => dispatch(newGrant(data)),
});

FindCharity.propTypes = {
  availableBalance: PropTypes.number,
  history: PropTypes.object,
  location: PropTypes.object,
  newGrant: PropTypes.func,
}

export default connect(mapStateToProps, mapDispatchToProps)(FindCharity);
